(function HotLists($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reports/hotList', function onload()
		{
			$('.nav-tabs li a').on('click', function updateUrl(e) {
				let newUrl = '';
				let tabName = $(this).attr('aria-controls');
				let currentUrl = window.location.href;
				var baseUrl = currentUrl.split('/hotList')[0] + '/hotList';

				e.preventDefault();

				switch (tabName) {
					case 'anniversaries':
						tabName = 'anniversary';
						break;
					case 'w2n_surveys':
						tabName = 'w2n_surveys';
						break;
					default:
						tabName = tabName.slice(0, -1);
						break;
				}

				newUrl = baseUrl + '/' + tabName;
				window.location.href = newUrl;
			});
		});
	});
}(jQuery, window.Adzuki || {}));
